import {useEffect, useState} from "react";


const ROIBarChartPillar = (props) => {
    const bar = props.bar
    const benchmark = props.benchmark
    const benchmarkEnabled = props.benchmarkEnabled
    const idx = props.idx
    const getPillarColour = props.getPillarColour
    const getPillarName = props.getPillarName
    const comparisonData = props.comparisonData
    const left = 100 * idx
    const handleBarHover = props.handleBarHover

    return(
        <>
            <div className="roi-bar-chart-table-column-container" key={idx}>
                <div className={`roi-barchart-table-column-top ${idx === 0 ? "left-corner" : idx === 5 ? "right-corner" : ""}`}/>
                <div className="roi-barchart-table-column-dark"/>
                <div className="roi-barchart-table-column-mid"/>
                <div className="roi-barchart-table-column-light">
                    <div className="roi-barchart-bar" style={{
                        height: bar.height, left: bar.left, right: bar.right, top: bar.top,
                        bottom: bar.bottom, backgroundColor: bar.colour,
                        border: `solid 1px ${bar.border_colour}`
                    }} onMouseOver={() => {handleBarHover(comparisonData, idx)}} onMouseLeave={() => handleBarHover(0, idx)}>
                        {bar.text}
                    </div>
                    {benchmarkEnabled ?
                        <div className="roi-barchart-bar benchmark" style={{
                            height: benchmark.height, left: benchmark.left, right: benchmark.right,
                            top: benchmark.top, bottom: benchmark.bottom,
                            border: `solid 1px ${benchmark.border_colour}`,
                            backgroundColor: benchmark.colour
                        }}>
                            {benchmark.text}
                        </div> : null
                    }
                </div>
                <div className="roi-barchart-table-column-bottom"/>
                <div className="roi-barchart-table-column-colourarea">
                    <div className="summary-graphical-table-column-text-container">
                        <div className={`summary-graphical-table-column-pillar-colour ${getPillarColour(idx + 1)}`}/>
                        <div className="roi-graphical-table-column-pillar-text">
                            {getPillarName(idx + 1)}
                        </div>
                    </div>
                </div>
            </div>
            {idx !== 5 ?
                <div className="summary-graphical-table-centre-spacer" key={`${idx} ${idx}`}>
                    <div className="roi-graphical-spacer-segment no-border"/>
                    <div className="roi-graphical-spacer-segment no-border"/>
                    <div className="roi-graphical-spacer-segment no-border"/>
                    <div className="roi-graphical-spacer-segment no-border"/>
                    <div className="roi-graphical-spacer-segment no-border"/>
                    <div className="roi-graphical-spacer-segment no-border"/>
                </div> : null
            }
        </>
    )
}

export default ROIBarChartPillar